<template>
  <div class="mx-3" style="page-break-inside: avoid; padding-bottom: 1em">
    <hr style="margin-top: 2em">
      <div class="row">
          <div class="col-9">
              <h2 class="pl-1" style="font-size: 1.2em; font-weight: bold">{{ observation.type.name }}</h2>
          </div>
          <div class="col-3 d-flex justify-content-end">
              <button class="btn btn-sm btn-danger form-button" @click="$emit('remove', observation.id)">
                  {{ $t('observations.remove_from_report')}}
              </button>
          </div>
      </div>
    <div v-if="observation.public === true">
      <span class="hint-text">{{ $t('observations.public') }}</span>
    </div>
    <div v-if="observation.info">
      <span
        class="item-detail-text"
        style="font-size: 1em; color: #636364; margin-bottom: .5em"
      >{{ observation.info ? observation.info : '' }}</span>
    </div>
    <div
      v-if="observation.photos.length > 1 && showAllPhotos"
      class="row nopads"
    >
      <div
        v-for="(photo, index) in observation.photos"
        :key="index"
        class="col-6 pb-2 multi-img-row"
      >
        <div class="image-container">
          <ImageView
            :img-size="'sm'"
            :url="getPhotoUrlForObservation(observationPhotoUrl, observation.id, photo)"
            :cache-photo="true"
            :cacheable-photo-id="photo.id"
            :contain="true"
            :height="'300px'"
            :control-size="'sm'"
            @image-loaded="onImageLoaded()"
          />
        </div>
      </div>
    </div>
    <div
      v-else-if="observation.photos.length > 0"
      class="nopads text-center"
    >
      <div class="col-12 nopads">
        <div class="image-container">
          <ImageView
            :img-size="'sm'"
            :url="getPhotoUrlForObservation(observationPhotoUrl, observation.id, observation.photos[0])"
            :cache-photo="true"
            :cacheable-photo-id="observation.photos[0].id"
            :contain="true"
            :height="'420px'"
            :control-size="'sm'"
            @image-loaded="onImageLoaded()"
          />
        </div>
      </div>
    </div>
      <div class="my-3">
          <!-- Fixed width div -->
          <div style="height: 300px; width: 730px; position: relative;">
              <marker-editor-map
                  v-if="observation"
                  :id="observation.id"
                  ref="markerEditorMap"
                  :lat="getLatitude(observation)"
                  :lon="getLongitude(observation)"
                  :points="getPoints(observation)"
                  :type="OBSERVATION"
                  :draggable="false"
                  @mounted="mapMounted"
                  style="height: 300px !important; width: 730px !important"
              />
          </div>

      </div>
      <!-- Flexible width div -->
      <div class="pt-4">
          <table class="table table-sm">
              <thead>
              <tr>
                  <th>{{ $t('observations.id') }}</th>
                  <th>{{ $t('observations.created_time') }}</th>
                  <th>{{ $t('contracts.name') }}</th>
                  <th>{{ $t('contracts.customer') }}</th>
                  <th>{{ $t('observations.order') }}</th>
                  <th>{{ $t('observations.location') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                  <td>{{ observation.id }}</td>
                  <td>{{ toLocalTime(observation.created_time) }}</td>
                  <td>{{ observation.contract ? observation.contract.name : '' }}</td>
                  <td>{{ observation.contract ? observation.contract.customer.name : '' }}</td>
                  <td>{{ observation.work_order && observation.work_order.task_type ? observation.work_order.task_type.name : '' }}</td>
                  <td>
                      <road-addess-view
                          :road-number="observation.road_number"
                          :section-number="observation.section_number"
                          :distance="observation.distance_from_sec_start"
                          :street-name="observation.street_name"
                          :show-title="false"
                          :enable-copy="false"
                      />
                      {{ observation.city && observation.city.name ? observation.city.name : '' }}
                  </td>
              </tr>
              </tbody>
          </table>
      </div>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import ImageView from '../view/ImageView'
import {restApi} from '../mixins/RestApiMixin'
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from '../mixins/MapMixin'
import {observationHelper} from '../mixins/ObservationMixin'
import {Pagination} from "@egjs/flicking-plugins";
import RoadAddessView from "@/components/velho/RoadAddressView";

export default {
    name: 'ObservationPrintDetails',
    components: {RoadAddessView, MarkerEditorMap, ImageView},
    mixins: [timeUtils, restApi, mapHelper, observationHelper],
    props: {
        observation: {
            type: Object,
            default() {
                return null
            }
        },
        reportCompleted: {
            type: Boolean,
            default() {
                return false
            }
        },
        showAllPhotos: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            mapReady: false,
            imgLoaded: 0,
            plugins: [new Pagination({type: 'bullet'})],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
        }
    },
    watch: {
        reportCompleted(val) {
            if (val && this.mapReady) {
                this.switchMapToImage()
            }
        },
        imgLoaded: function() {
            if (this.imgLoaded === this.observation.photos.length) {
                this.$emit('loadingCompleted')
            }
        }
    },
    created() {
        if (this.observation.photos && this.observation.photos.length > 0) {
            this.$emit('loadingStarted')
        } else if (!this.observation.photos || this.observation.photos.length < 1) {
            this.$emit('loadingCompleted')
        }
    },
    methods: {
        getMarkerEditorMap() {
            return this.map.getMap()
        },
        getPhotoUrlForObservation: function (baseUrl, observationId, photo) {
            return baseUrl + '/' + observationId + '/' + photo.id
        },
        mapMounted(map) {
            this.map = map
            this.mapReady = true
            if (this.reportCompleted) {
                // No photos in report, give time for map to load
                setTimeout(() => this.switchMapToImage(), 3000 )
            }
            this.$nextTick(() => this.map.hideMapControls())
        },
        switchMapToImage() {
                this.$emit('readyToPrint')
        },
        onImageLoaded() {
            this.imgLoaded++
        },
    }
}
</script>

<style scoped>

.detail-map, .report-photos {
    display: block;
    height: 250px;
    width: 450px;
    overflow: hidden;
}

.detail-map {
    position: absolute;
    border-radius: 1.2em;
    border: 1px solid #BCBCBC;
}

.report-photos {
    margin-top: 210px;
}
.image-container {
    width: fit-content;
    margin: auto;
}
</style>

